import { MetaInfoState } from '@sravni/react-silent-authentication-form/dist/types/components/ContextProvider/components/MetainfoProvider';

const MetaInfoStateConfig: MetaInfoState = {
    authCodeChannel: 'Sms',
    source: 'Анкета подбора кредита',
    customer: 'creditselection-frontend',
    productName: 'Старый Подбор кредита',
};

export const AuthInlineFormConfig = {
    texts: {
        consentsScreenTitle: 'Подтвердите согласие на получение выгодных предложений и информации',
        bannerTitle: 'Кредиты на Сравни',
        bannerAdsTextsList: [
            'Проверка доступной суммы кредита',
            'Получите решение онлайн',
            'Предложения от топовых банков',
        ],
        advertisingCheckboxLabel: 'Даю согласие на получение {link|рекламы} и информационных сообщений',
    },
    metaInfo: MetaInfoStateConfig,
};
